<ol class="container-fluid breadcrumb row align-items-center no-gutters" *ngIf="isDisplayed">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let index = index; let first = first; let last = last">
    <li *ngIf="first; else others" class="home mt-1" [routerLink]="[breadcrumb.url]"
      [class.active]="breadcrumbs.length <= 1" style="z-index: 11;">{{ breadcrumb.label}}</li>
    <ng-template #others>
      <div class="slash">//</div>
      <li *ngIf="breadcrumb.url" [class.active]="last" class="mt-1" [style.z-index]="10 - index"
        [routerLink]="[breadcrumb.url]">
        {{ breadcrumb.label}}
      </li>
      <li *ngIf="!breadcrumb.url" [class.active]="last" class="mt-1" [routerLink]="[breadcrumb.url]" [style.z-index]="10 - index">
        {{ breadcrumb.label}}
      </li>
    </ng-template>
  </ng-container>
</ol>